
            import { loadAppsAsJson } from "./convertJson.js";

            document.addEventListener("DOMContentLoaded", async () => {
                const submissions = await loadAppsAsJson();

                const container = document.querySelector(".application-container");
                container.innerHTML = "";

                submissions.forEach(item => {
                    const applicationItem = document.createElement("div");
                    applicationItem.classList.add("application-item");

                    applicationItem.innerHTML = `<img src="${item.Thumbnail}" alt="${item.Name || 'Submission'}" class="application-image" />
        <p class="application-caption">${item.Name || "Untitled"}</p>
      `;

                    container.appendChild(applicationItem);
                });

                document.querySelectorAll(".application-image").forEach((img, index) => {
                    img.addEventListener("click", () => {
                        const submission = submissions[index]; // same ordering
                        console.log(submission);
                        // Fill modal
                        document.getElementById("modal-gif").src = submission.Thumbnail;

                        document.getElementById("modal-meta").innerHTML = `
                    <p><strong>Name:</strong> ${submission.Name}</p>
                    <p><strong>Year:</strong> ${submission.Year || "Unknown"}</p>
                    <p><strong>Description:</strong> ${submission.Description || "No description"}</p>
                    
                `;

                        document.getElementById("gif-modal").classList.remove("hidden");
                    });
                });

                // Close button
                document.getElementById("close-modal").addEventListener("click", () => {
                    document.getElementById("gif-modal").classList.add("hidden");
                });

                // Optional: close modal when clicking background
                document.getElementById("gif-modal").addEventListener("click", (e) => {
                    if (e.target.id === "gif-modal") {
                        document.getElementById("gif-modal").classList.add("hidden");
                    }
                });


            });
        